<script lang="ts">
	import { PrimaryKeyIcon } from '@repo/commons/components'

	type Props = {
		text: string
		htmlFor?: string
		showPrimaryKey?: boolean
	}

	const { text, showPrimaryKey = false, htmlFor }: Props = $props()
</script>

<label class="pk-field-label" for={htmlFor}>
	<span class="pk-field-label-text">{text}</span>
	{#if showPrimaryKey}
		<PrimaryKeyIcon />
	{/if}
</label>

<style lang="postcss">
	.pk-field-label {
		@apply flex items-center gap-1 text-base text-[#001626E5] leading-6;
	}

	.pk-field-label-text {
		@apply min-w-0 truncate;
	}
</style>
